"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/*globals Kobo, $, hcaptcha*/
var HCaptchaWrapper = /*#__PURE__*/function () {
  function HCaptchaWrapper() {
    _classCallCheck(this, HCaptchaWrapper);

    if (HCaptchaWrapper._instance) return HCaptchaWrapper._instance;
    HCaptchaWrapper._instance = this;
    this.containerWidgetMapping = {};
    this.registerEventHandlers();
    this.renderAllCaptchaContainers();
  }

  _createClass(HCaptchaWrapper, [{
    key: "handleExecuteAsync",
    value: function handleExecuteAsync(_, data) {
      var _this = this;

      var _data$detail = data.detail,
          containerId = _data$detail.containerId,
          successCallback = _data$detail.successCallback,
          failureCallback = _data$detail.failureCallback;
      var widgetId = this.containerWidgetMapping[containerId];
      return hcaptcha.execute(widgetId, {
        async: true
      }).then(successCallback)["catch"](function (err) {
        console.error(err); // because we are invoking hcaptcha programmatically, we need to handle certain errors ourselves as per the documentation
        // https://docs.hcaptcha.com/configuration/#error-codes

        if (err === 'challenge-error' || err === 'internal-error') return _this.handleExecuteAsync(_, data);
        failureCallback(err);
      });
    }
  }, {
    key: "handleReset",
    value: function handleReset(_, data) {
      var containerId = data.detail.containerId;
      var widgetId = this.containerWidgetMapping[containerId];
      hcaptcha.reset(widgetId);
    }
  }, {
    key: "renderAllCaptchaContainers",
    value: function renderAllCaptchaContainers() {
      var _this2 = this;

      var CaptchaEvent = Kobo.Utilities.HCaptcha.CaptchaEvent;
      $('.h-captcha').each(function (_, element) {
        var widgetId = hcaptcha.render(element, {
          sitekey: $(element).data('sitekey'),
          size: $(element).data('size'),
          'callback': function callback() {
            _this2.recordCaptchaEvent({
              eventType: CaptchaEvent.ChallengeCompleted,
              containerId: $(element).attr('id')
            });
          },
          'open-callback': function openCallback() {
            _this2.recordCaptchaEvent({
              eventType: CaptchaEvent.ChallengeOpened,
              containerId: $(element).attr('id')
            });
          },
          'close-callback': function closeCallback() {
            _this2.recordCaptchaEvent({
              eventType: CaptchaEvent.ChallengeClosed,
              containerId: $(element).attr('id')
            });
          },
          'error-callback': function errorCallback(error) {
            _this2.recordCaptchaEvent({
              eventType: CaptchaEvent.ChallengeError,
              containerId: $(element).attr('id'),
              error: error
            });
          },
          'chalexpired-callback': function chalexpiredCallback() {
            _this2.recordCaptchaEvent({
              eventType: CaptchaEvent.ChallengeExpired,
              containerId: $(element).attr('id')
            });
          }
        });
        var elementId = $(element).attr('id');
        _this2.containerWidgetMapping[elementId] = widgetId;
      });
    }
  }, {
    key: "registerEventHandlers",
    value: function registerEventHandlers() {
      Kobo._mediator.register('hcaptcha::executeAsync');

      Kobo._mediator.register('hcaptcha::reset');

      Kobo._mediator.subscribe('hcaptcha::executeAsync', this.handleExecuteAsync.bind(this));

      Kobo._mediator.subscribe('hcaptcha::reset', this.handleReset.bind(this));
    }
  }, {
    key: "recordCaptchaEvent",
    value: function recordCaptchaEvent(captchaEvent) {
      console.dir(captchaEvent);
      $.ajax({
        type: 'POST',
        url: '/captcha/recordevent',
        headers: {
          '__RequestVerificationToken': Kobo.Utilities.getAntiForgeryToken()
        },
        dataType: 'json',
        data: _objectSpread({}, captchaEvent)
      });
    }
  }], [{
    key: "init",
    value: function init() {
      if (window.hcaptcha) {
        return new HCaptchaWrapper();
      } else {
        console.error('HCaptcha is not loaded.');
      }
    }
  }]);

  return HCaptchaWrapper;
}();

(function () {
  Kobo.Utilities.assignToNamespace('Kobo.Utilities.HCaptcha.CaptchaEvent', Kobo.Enum.define({
    Unknown: ['unknown', 0],
    ChallengeCompleted: ['challengeCompleted', 1],
    ChallengeOpened: ['challengeOpened', 2],
    ChallengeClosed: ['challengeClosed', 3],
    ChallengeError: ['challengeError', 4],
    ChallengeExpired: ['challengeExpired', 5]
  }));
})();

(function () {
  window.hcaptchaOnload = HCaptchaWrapper.init;
})();

Kobo.Utilities.assignToNamespace('Kobo.Utilities.HCaptchaWrapper', HCaptchaWrapper);